import React from "react";
import { Button } from "antd";
import JobCard, { failMessage, JobCardProps } from "components/jobs/JobCard";
import JobItemList from "components/jobs/JobItemList";
import { BatchJob, BatchJobItem } from "reducers/types";

export interface ItemizedJobCardProps extends Omit<JobCardProps, "renderBody" | "renderSummary"> {
  /** Extra text per item (e.g. counts from item.details). */
  renderDetails?: (item: BatchJobItem) => React.ReactNode;
}

const summary = (job: BatchJob) =>
  `${job.processed}/${job.total} — ✓ ${job.succeeded} · no data ${job.noData} · ✗ ${job.failed}` +
  (job.skipped > 0 ? ` · skipped ${job.skipped}` : "") +
  (job.currentItem ? ` · now: ${job.currentItem}` : "");

// View of an itemized job (server: ItemizedJobHandler): per-item list with Retry, "Retry all failed", item counts.
const ItemizedJobCard: React.FC<ItemizedJobCardProps> = ({ renderDetails, ...props }) => (
  <JobCard
    {...props}
    renderSummary={summary}
    renderBody={(job, jobs) => {
      const retryable = job.failed + job.skipped;
      return (
        <>
          <JobItemList
            items={job.items || []}
            renderDetails={renderDetails}
            onRetry={(key) => jobs.retry([key]).then(failMessage("Retry was not accepted"))}
          />
          {retryable > 0 ? (
            <Button onClick={() => jobs.retry().then(failMessage("Retry was not accepted"))}>
              Retry all failed ({retryable})
            </Button>
          ) : null}
        </>
      );
    }}
  />
);

export default ItemizedJobCard;
